import type {
  IAudioStreamUrlResponse,
  IConfirmAudioUploadParams,
  IConfirmAudioUploadResult,
  IGetAudioStreamUrlPayload,
  IGetUploadedMeetingsParams,
  IPaginatedUploadedMeetingsResponse,
  IPresignAudioUploadParams,
  IPresignAudioUploadResult,
} from "../types/vstr-audio";
import type { ApiClient } from "./client";

export class VstrAudioApi {
  constructor(private readonly apiClient: ApiClient) {}

  async getUploadedMeetings(
    params: IGetUploadedMeetingsParams = {},
  ): Promise<IPaginatedUploadedMeetingsResponse> {
    const response =
      await this.apiClient.get<IPaginatedUploadedMeetingsResponse>(
        "/vstr-audio/uploaded-meetings",
        { params },
      );
    return response.data;
  }

  async presignUpload(
    params: IPresignAudioUploadParams,
  ): Promise<IPresignAudioUploadResult> {
    const response = await this.apiClient.post<IPresignAudioUploadResult>(
      "/vstr-audio/presign-upload",
      params,
    );
    return response.data;
  }

  async confirmUpload({
    signal,
    ...params
  }: IConfirmAudioUploadParams): Promise<IConfirmAudioUploadResult> {
    const response = await this.apiClient.post<IConfirmAudioUploadResult>(
      "/vstr-audio/confirm-upload",
      params,
      { signal },
    );
    return response.data;
  }

  async getStreamUrl(
    payload: IGetAudioStreamUrlPayload,
  ): Promise<IAudioStreamUrlResponse> {
    const response = await this.apiClient.post<IAudioStreamUrlResponse>(
      "/vstr-audio/stream-url",
      payload,
    );
    return response.data;
  }
}
